import sanityClient from '@sanity/client';
export { default as groq } from 'groq';
function createClient(config) {
  return sanityClient(config);
}
export { createClient };
//# sourceMappingURL=index.js.map
